Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _typeValidation = require('./typeValidation');

var _typeValidation2 = _interopRequireDefault(_typeValidation);

var _lodash = require('lodash.isequal');

var _lodash2 = _interopRequireDefault(_lodash);

require('@pcty/list/lib/css/index.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PctyList = function (_React$Component) {
  _inherits(PctyList, _React$Component);

  function PctyList(props) {
    _classCallCheck(this, PctyList);

    var _this = _possibleConstructorReturn(this, (PctyList.__proto__ || Object.getPrototypeOf(PctyList)).call(this, props));

    _this.dividerOnClick = _this.dividerOnClick.bind(_this);

    _this.state = {
      inactiveIndexes: [],
      props: props
    };
    return _this;
  }

  // componentWillReceiveProps(nextProps) {
  //   if (!isEqual(this.props.children, nextProps.children)) {
  //     this.setState({
  //       inactiveIndexes: [],
  //     });
  //   }
  // }

  _createClass(PctyList, [{
    key: 'dividerOnClick',
    value: function dividerOnClick(index) {
      if (this.state.inactiveIndexes.indexOf(index) >= 0) {
        this.setState({ inactiveIndexes: this.state.inactiveIndexes.filter(function (x) {
            return x !== index;
          }) });
        return;
      }

      this.setState({ inactiveIndexes: [].concat(_toConsumableArray(this.state.inactiveIndexes), [index]) });
    }
  }, {
    key: 'render',
    value: function render() {
      var other = Object.assign({}, this.props);
      for (var prop in propTypes) {
        delete other[prop];
      }

      var otherProps = _extends({}, other, {
        className: ((other.className || '') + ' pcty-list').trim(),
        'data-automation-id': this.props.automationId || null
      });

      switch (this.props.borderMode) {
        case 'top-none':
        case 'bottom-none':
          otherProps.className = otherProps.className + ' pcty-border-' + this.props.borderMode;
          break;
        case 'open':
          otherProps.className = otherProps.className + ' pcty-border-top-none pcty-border-bottom-none';
          break;
        default:
          break;
      }
      if (!this.props.hover) {
        otherProps.className = otherProps.className + ' pcty-list-nohover';
      }

      if (this.props.accordion) {
        return _react2.default.createElement(
          'table',
          otherProps,
          _react2.default.createElement(
            'tbody',
            { className: 'pcty-list-group' },
            renderAccordionChildren(this.props.children, this.state.inactiveIndexes, this.dividerOnClick)
          )
        );
      }

      return _react2.default.createElement(
        'table',
        otherProps,
        _react2.default.createElement(
          'tbody',
          { className: 'pcty-list-group' },
          this.props.children
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (!(0, _lodash2.default)(state.props.children, props.children)) {
        return {
          inactiveIndexes: [],
          props: props
        };
      }

      return null;
    }
  }]);

  return PctyList;
}(_react2.default.Component);

;

var renderAccordionChildren = function renderAccordionChildren(children, inactiveIndexes, dividerOnClick) {
  return _react2.default.Children.map(children, function (child, index) {
    if (child.props.__TYPE === 'PctyListGroup') {
      return _react2.default.cloneElement(child, {
        onClick: dividerOnClick,
        index: index,
        active: inactiveIndexes.indexOf(index) < 0
      });
    }

    return child;
  });
};

var propTypes = {
  /** When using dividers, renders child elements to be toggleable */
  accordion: _propTypes2.default.bool,
  /** Removes borders from container */
  borderMode: _propTypes2.default.oneOf(['', 'top-none', 'bottom-none', 'open']),
  /** If false, removes hovers from all list items */
  hover: _propTypes2.default.bool,
  /** A string that can be referenced by UI automation tools */
  automationId: _propTypes2.default.string,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation2.default)(props, propName, componentName, 'PctyList');
  }
};

PctyList.propTypes = propTypes;

PctyList.defaultProps = {
  accordion: false,
  borderMode: '',
  hover: true,
  __TYPE: 'PctyList'
};

exports.default = PctyList;